import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
export const Section = forwardRef(function SectionComponent({ children, testId, hasDivider = true, id, hasPaddingLeft = true, hasPaddingRight = true, BoxProps, DividerBoxProps, unsafeClassname, display = "block", }, ref) {
    return (_jsxs(Box, { ref: ref, as: "section", id: id, testId: testId, unsafe_className: `Section ${unsafeClassname !== null && unsafeClassname !== void 0 ? unsafeClassname : ""}`, display: display, children: [_jsx(Box, { paddingRight: {
                    "breakpoint.base": hasPaddingRight ? "spacing.16" : "spacing.none",
                    "breakpoint.sm": hasPaddingRight ? "spacing.32" : "spacing.none",
                    "breakpoint.lg": "spacing.none",
                }, paddingLeft: {
                    "breakpoint.base": hasPaddingLeft ? "spacing.16" : "spacing.none",
                    "breakpoint.sm": hasPaddingLeft ? "spacing.32" : "spacing.none",
                    "breakpoint.lg": "spacing.none",
                }, ...BoxProps, children: children }), hasDivider && (_jsx(Box, { paddingHorizontal: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                    "breakpoint.lg": "spacing.none",
                }, ...DividerBoxProps, children: _jsx(Divider, { "aria-hidden": "true", marginTop: "spacing.40", marginBottom: "spacing.40" }) }))] }));
});
